export const apiConfigs = {
    baseURL : "https://pakhshman.ir/v1/",
};
